export default {
      id: "dragSortArrows-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#dragSortArrows-usage",
      toString: function () {
        return this.url;
      }
    }